import React from "react";
import {
  FileOpenOutlined,
  Inventory2Outlined,
  DashboardOutlined,
  ContactMailOutlined,
  MarkUnreadChatAltOutlined,
  AdminPanelSettingsOutlined,
  ManageAccountsOutlined,
  SettingsOutlined,
  AccountTreeOutlined,
  CardMembershipOutlined,
  CreditCardOutlined,
  PaidOutlined,
  SmsFailedOutlined,
  BugReportOutlined,
  RateReviewOutlined,
  AccessibilityOutlined,
  PeopleAltOutlined,
  GroupsOutlined,
} from "@mui/icons-material";

// List of all Menu items in the entire application with each menu item being an object that might or might not have a submenu. Submenus are presented as arrays while submenu items are presented as objects within these arrays
export const MenuData = [
  {
    id: "Dashboard",
    permissionCategoryName: "Dashboard",
    permissionCategoryId: "Dashboard",
    permissionId: "View",
    icon: <DashboardOutlined />,
    path: "/dashboard",
  },

  {
    id: "MembershipApplication",
    permissionCategoryName: "Membership Application",
    permissionCategoryId: "MembershipApplication",
    permissionId: "View",
    icon: <ContactMailOutlined />,
    path: "/membershipapplication",
  },

  {
    id: "MembershipRequests",
    permissionCategoryName: "Membership Requests",
    permissionCategoryId: "MembershipRequests",
    permissionId: "View",
    icon: <GroupsOutlined />,
    path: "/membershiprequests",
  },

  {
    id: "MembershipApproval",
    permissionCategoryName: "Membership Approvals",
    permissionCategoryId: "MembershipApproval",
    permissionId: "View",
    icon: <MarkUnreadChatAltOutlined />,
    path: "/membershipapprovals",
  },

  {
    id: "MembershipDirectory",
    permissionCategoryName: "Membership Directory",
    permissionCategoryId: "MembershipDirectory",
    permissionId: "View",
    icon: <Inventory2Outlined />,
    path: "/membershipdirectory",
  },

  {
    id: "AccessRequests",
    permissionCategoryName: "Access Requests",
    permissionCategoryId: "AccessRequests",
    permissionId: "View",
    icon: <FileOpenOutlined />,
    path: "/accessrequests",
  },

  {
    id: "AdminManagement",
    permissionCategoryName: "Admin",
    permissionCategoryId: "AdminManagement",
    permissionId: "View",
    icon: <PeopleAltOutlined />,
    subMenu: [
      {
        id: "RoleManagement",
        permissionCategoryName: "Manage Role",
        permissionCategoryId: "ManageRole",
        permissionId: "View",
        icon: <AdminPanelSettingsOutlined />,
        path: "/rolemanagement",
      },

      {
        id: "UserManagement",
        permissionCategoryName: "Manage User",
        permissionCategoryId: "ManageUser",
        permissionId: "View",
        icon: <ManageAccountsOutlined />,
        path: "/usermanagement",
      },

      {
        id: "MasterList",
        permissionCategoryName: "Master List",
        permissionCategoryId: "MasterList",
        permissionId: "View",
        icon: <SettingsOutlined />,
        path: "/masterlist",
      },

      {
        id: "WorkflowManagement",
        permissionCategoryName: "Manage Workflow",
        permissionCategoryId: "WorkflowManagement",
        permissionId: "View",
        icon: <AccountTreeOutlined />,
        path: "/workflowmanagement",
      },

      {
        id: "MembershipTierManagement",
        permissionCategoryName: "Manage Membership Category",
        permissionCategoryId: "MembershipTierManagement",
        permissionId: "View",
        icon: <CardMembershipOutlined />,
        path: "/membershipcategorymanagement",
      },
    ],
  },

  {
    id: "Payments",
    permissionCategoryName: "Payments",
    permissionCategoryId: "Payments",
    permissionId: "View",
    icon: <CreditCardOutlined />,
    subMenu: [
      {
        id: "AllPayments",
        permissionCategoryName: "All Payments",
        permissionCategoryId: "AllPayments",
        permissionId: "View",
        icon: <PaidOutlined />,
        path: "/payments",
      },

      {
        id: "MyPayments",
        permissionCategoryName: "My Payments",
        permissionCategoryId: "MyPayments",
        permissionId: "View",
        icon: <PaidOutlined />,
        path: "/mypayments",
      },
    ],
  },


  // {
  //   id: "Settings",
  //   permissionCategoryName: "Settings",
  //   permissionCategoryId: "Settings",
  //   permissionId: "View",
  //   icon: <Settings />,
  //   path: "/masterlist",
  // },

  {
    id: "Feedback",
    permissionCategoryName: "Feedback",
    permissionCategoryId: "Feedback",
    permissionId: "View",
    icon: <SmsFailedOutlined />,
    subMenu: [
      {
        id: "BugReporting",
        permissionCategoryName: "Report Bug",
        permissionCategoryId: "BugReporting",
        permissionId: "View",
        icon: <BugReportOutlined />,
        path: "/bugreporting",
      },

      {
        id: "SendFeedback",
        permissionCategoryName: "Send Feedback",
        permissionCategoryId: "SendFeedback",
        permissionId: "View",
        icon: <RateReviewOutlined />,
        path: "/feedback",
      },
    ],
  },

  {
    id: "HelpAndSupport",
    permissionCategoryName: "Help & Support Center",
    permissionCategoryId: "Support",
    permissionId: "View",
    icon: <AccessibilityOutlined />,
    path: "/help&support",
  },
];
